import { eqBy,prop, unionWith } from "ramda";
import { projectDefaultState } from "../../project.duck";

export const defaultScopeId = "v3.users";
export const contextKey = "project";

export const LOAD_SUCCEEDED = "USERS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "USERS/LOAD_FAILED";
export const LOAD_REQUESTED = "USERS/LOAD_REQUESTED";
export const LOAD_SINGLE_SUCCEEDED = "USERS/LOAD_SINGLE_SUCCEEDED";
export const LOAD_SINGLE_FAILED = "USERS/LOAD_SINGLE_FAILED";
export const LOAD_SINGLE_REQUESTED = "USERS/LOAD_SINGLE_REQUESTED";
export const LOAD_ASSIGNABLE_TO_WORKFLOW_SUCCEEDED = "USERS/LOAD_ASSIGNABLE_TO_WORKFLOW_SUCCEEDED";
export const LOAD_ASSIGNABLE_TO_WORKFLOW_FAILED = "USERS/LOAD_ASSIGNABLE_TO_WORKFLOW_FAILED";
export const LOAD_ASSIGNABLE_TO_WORKFLOW_REQUESTED = "USERS/LOAD_ASSIGNABLE_TO_WORKFLOW_REQUESTED";
export const CREATE_SUCCEEDED = "USERS/CREATE_SUCCEEDED";
export const CREATE_FAILED = "USERS/CREATE_FAILED";
export const CREATE_REQUESTED = "USERS/CREATE_REQUESTED";
export const CHANGE_MULTIPLE_STATUS_SUCCEEDED = "USERS/CHANGE_MULTIPLE_STATUS_SUCCEEDED";
export const CHANGE_MULTIPLE_STATUS_FAILED = "USERS/CHANGE_MULTIPLE_STATUS_FAILED";
export const CHANGE_MULTIPLE_STATUS_REQUESTED = "USERS/CHANGE_MULTIPLE_STATUS_REQUESTED";
export const CHANGE_STATUS_SUCCEEDED = "USERS/CHANGE_STATUS_SUCCEEDED";
export const CHANGE_STATUS_FAILED = "USERS/CHANGE_STATUS_FAILED";
export const CHANGE_STATUS_REQUESTED = "USERS/CHANGE_STATUS_REQUESTED";
export const UPDATE_SUCCEEDED = "USERS/UPDATE_SUCCEEDED";
export const UPDATE_FAILED = "USERS/UPDATE_FAILED";
export const UPDATE_REQUESTED = "USERS/UPDATE_REQUESTED";

const mergeGroupsById = unionWith(eqBy(prop("id")));
const mergeUsersById = unionWith(eqBy(prop("_id")));
const findById = userId => ({ _id: id }) =>  userId === id;

// eslint-disable-next-line complexity, max-statements
export default (
    state = projectDefaultState(),
    { type, data }
) => {
    if (!state.users) state.users = [];
    switch (type) {
    case LOAD_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.users = mergeUsersById(
            data.users,
            state.users
        );
        state.groups = mergeGroupsById(
            data.groups,
            state.groups
        );
        return state;
    }
    case LOAD_SINGLE_REQUESTED: {
        ++state.loading;
        const { _id: id } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.loading = true;
        }
        return state;
    }
    case LOAD_SINGLE_FAILED: {
        --state.loading;
        const { _id: id, error } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.loading = false;
            user.error = error;
        }
        state.errors.push({ error, id, type });
        return state;
    }
    case LOAD_SINGLE_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        const { _id: id, ...properties } = data;
        const user = state.users.find(findById(id));
        if (user) {
            Object.assign(
                user,
                properties,
                {
                    loading: false,
                }
            );
        } else {
            state.users.push(data);
        }
        return state;
    }
    case UPDATE_REQUESTED: {
        ++state.updating;
        const { _id: id } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.updating = true;
        }
        return state;
    }
    case UPDATE_FAILED: {
        --state.updating;
        const { _id: id, error } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.updating = false;
            user.error = error;
        }
        state.errors.push({ error, id, type });
        return state;
    }
    case UPDATE_SUCCEEDED: {
        --state.updating;
        const { _id: id, ...properties } = data;
        const user = state.users.find(findById(id));
        if (user) {
            Object.assign(
                user,
                properties,
                {
                    updating: false,
                }
            );
        }
        return state;
    }
    case CREATE_REQUESTED: {
        ++state.creating;
        return state;
    }
    case CREATE_FAILED: {
        --state.creating;
        state.errors.push({ error: data, type });
        return state;
    }
    case CREATE_SUCCEEDED: {
        --state.creating;
        const { _id: id, ...properties } = data;
        const user = state.users.find(findById(id));
        if (user) {
            Object.assign(
                user,
                properties,
            );
        } else {
            state.users.push(data);
        }
        return state;
    }
    case CHANGE_MULTIPLE_STATUS_SUCCEEDED: {
        data.forEach(({ userId, group }) => {
            --state.deactivating;
            const user = state.users.find(findById(userId));
            if (user){
                user.groups[0] = group;
                user.deactivating = false;
            }
        });
        return state;
    }
    case CHANGE_MULTIPLE_STATUS_FAILED: {
        const { userIds, error } = data;
        userIds.forEach(id => {
            --state.deactivating;
            const user = state.users.find(findById(id));
            if (user){
                user.deactivating = false;
                user.error = error;
            }
            state.errors.push({ error: data, type });
        });
        return state;
    }
    case CHANGE_MULTIPLE_STATUS_REQUESTED: {
        data.userData.forEach(({ userId }) => {
            ++state.deactivating;
            const user = state.users.find(findById(userId));
            if (user){
                user.deactivating = true;
            }
        });
        return state;
    }
    case CHANGE_STATUS_SUCCEEDED: {
        --state.deactivating;
        const { userId, group } = data;
        const user = state.users.find(findById(userId));
        if (user){
            user.groups[0] = group;
            user.deactivating = false;
        }
        return state;
    }
    case CHANGE_STATUS_FAILED: {
        --state.deactivating;
        const { _id: id, error } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.deactivating = false;
            user.error = error;
        }
        state.errors.push({ error: data, type });
        return state;
    }
    case CHANGE_STATUS_REQUESTED: {
        ++state.deactivating;
        const { _id: id } = data;
        const user = state.users.find(findById(id));
        if (user){
            user.deactivating = true;
        }
        return state;
    }
    case LOAD_ASSIGNABLE_TO_WORKFLOW_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_ASSIGNABLE_TO_WORKFLOW_FAILED: {
        --state.loading;
        const { entityId, entityType, error } = data;
        state.errors.push({ error, entityId, entityType, type });
        return state;
    }
    case LOAD_ASSIGNABLE_TO_WORKFLOW_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.users = mergeUsersById(
            data,
            state.users
        );
        return state;
    }
    default:
        return state;
    }
};

export const successLoadUsers = data => ({ type: LOAD_SUCCEEDED, data });
export const failLoadUsers = data => ({ type: LOAD_FAILED, data });
export const requestLoadUsers = data => ({ type: LOAD_REQUESTED, data });

export const successLoadUser = data => ({ type: LOAD_SINGLE_SUCCEEDED, data });
export const failLoadUser = data => ({ type: LOAD_SINGLE_FAILED, data });
export const requestLoadUser = (data, resolve, reject) => ({ type: LOAD_SINGLE_REQUESTED, data, resolve, reject });

export const successLoadUsersAssignableToWorkflow = data => ({ type: LOAD_ASSIGNABLE_TO_WORKFLOW_SUCCEEDED, data });
export const failLoadUsersAssignableToWorkflow = data => ({ type: LOAD_ASSIGNABLE_TO_WORKFLOW_FAILED, data });
export const requestLoadUsersAssignableToWorkflow = data => ({ type: LOAD_ASSIGNABLE_TO_WORKFLOW_REQUESTED, data });

export const successCreateUser = data => ({ type: CREATE_SUCCEEDED, data });
export const failCreateUser = data => ({ type: CREATE_FAILED, data });
export const requestCreateUser = (data, resolve, reject) => ({ type: CREATE_REQUESTED, data, resolve, reject });

export const successChangeUsersStatus = data => ({ type: CHANGE_MULTIPLE_STATUS_SUCCEEDED, data });
export const failChangeUsersStatus = data => ({ type: CHANGE_MULTIPLE_STATUS_FAILED, data });
export const requestChangeUsersStatus = (data, resolve, reject) => ({ type: CHANGE_MULTIPLE_STATUS_REQUESTED, data, resolve, reject });

export const successChangeUserStatus = data => ({ type: CHANGE_STATUS_SUCCEEDED, data });
export const failChangeUserStatus = data => ({ type: CHANGE_STATUS_FAILED, data });
export const requestChangeUserStatus = (data, resolve, reject) => ({ type: CHANGE_STATUS_REQUESTED, data, resolve, reject });

export const successUpdateUser = data => ({ type: UPDATE_SUCCEEDED, data });
export const failUpdateUser = data => ({ type: UPDATE_FAILED, data });
export const requestUpdateUser = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
